import { useState } from "react"
import { useNavigate } from "react-router-dom"
import {getAuth, signInWithEmailAndPassword} from 'firebase/auth'
import visibilityIcon from '../assets/svg/visibilityIcon.svg'
import {toast} from 'react-toastify'
import EasyAdminLogo from '../Images/EasyAdminLogo2.png';
import '../Styles/button.css'

function SignIn() {
  const [showPassword, setShowpassword] = useState(false)
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })
  const { email, password } = formData
  
  const navigate = useNavigate()

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }))
  }
  const onSubmit = async (e) => {
    e.preventDefault();

    try {
        const auth = getAuth();
        const userCredentials = await signInWithEmailAndPassword(auth, email, password);

        if (userCredentials.user) {
            window.location.href = '/';
        }
    } catch (error) {
        toast.error('Bruger findes ikke!');
    }
};
  const onForgotPassword = () => {
    navigate('/forgot-password')
  }
  const onImageClick = () => {
    navigate('/')
  }
  return (
    <>
      <div className="pageContainer">
        <header>
          <img onClick={onImageClick} src={EasyAdminLogo} alt="easyadminLogo"></img>
         <p className="pageHeader d-flex justify-content-center">Velkommen Til Easy-admin!</p>
        </header>
        <main>
          <form onSubmit={onSubmit}>
            <input 
            type="email" 
            className="emailInput border" 
            placeholder="Email" 
            id="email" 
            value={email} 
            onChange={onChange} />
            <div className="passwordInputDiv">
              <input 
              type={showPassword ? 'text' : 'password'}
              className="passwordInput border"
              placeholder="Password"
              id="password" 
              value={password} 
              onChange={onChange} />
              <img src={visibilityIcon} alt="show password" className="showPassword" onClick={() => setShowpassword((prevState) => !prevState)} />
            </div>
            
            <div className="d-flex justify-content-center">
              <button className="login-btn">Login</button>
            </div>
          </form>
          <div className="d-flex justify-content-center mt-2">
            <button className="redirect-btn" onClick={onForgotPassword}>Glemt kode?</button>
            </div>
          <p className="d-flex justify-content-center mt-2" style={{fontWeight:'bold'}} >
          © 2023 Easy-Admin. All rights reserved.
          </p>
        </main>
      </div>
    </>
  )
}

export default SignIn;